/*global ViewController, WebView, moment*/

var notificationController = new ViewController(
    {
        directory: "views/notification",
        name: "notificationPopup",
        route: "notifications",
        openInPopup: true,
        noTitle: true,
        popup: {
            size: "medium"
        },
    }
);


notificationController.prepareDataOnEnter = function(data, callback) {
    var hasNewItem = false;
    this.api.db.multiread({
        iz_notification: {
            search: {
                real_user_id: this.api.currentUser.id,
                state: ["new", "view", "sent"],
                date: {ope:"between", value: [moment().subtract(1, "month").toDate(), new Date()]}
            },
            orderBy: "date desc"
        },
        iz_map: {
            searchFirst: {
                user_uid: this.api.currentUser.id,
                code: "notification_popup",
                key: "showReadNotifications",
                realm_code: ''
            }
        }
    }, function(err, reads){
        if(err){ return callback(err) ;}

        reads.iz_notification.forEach(function(notif){
            notif.typeLabel = WebView.tr("notification."+notif.type);
            notif.label = WebView.tr(notif.label);
            if("notification."+notif.type === notif.typeLabel){
                notif.typeLabel = notif.label ;
            }
            if (notif.state == "new" || notif.state == "sent") {
                hasNewItem = true;
            }
        }) ;

        var showRead = reads.iz_map && reads.iz_map.value && reads.iz_map.value.showReadNotifications ? true : false;

        this._allNotifs = reads.iz_notification || [];

        var visibleNotifs = this._allNotifs.filter(function(n){
            if(showRead){ return true; }
            return n.state !== 'view';
        });

        var readCount = this._allNotifs.filter(function(n){ return n.state === 'view'; }).length;

        callback(null, {
            notifs: visibleNotifs,
            hasNewItem: hasNewItem,
            showReadNotifications: showRead,
            readCount: readCount
        }) ;
    }.bind(this)) ;
} ;

notificationController.onLink = function(ev){
    this.view.longTask(function(done){
        this.api.db.transactionalChanges([
            { 
                table: "iz_notification",
                action: "update",
                record: {
                    id: ev.data.data.id,
                    state: "view"
                }
            }
        ], function(err){
            if(err){ return done(err) ;}
            window.location.href = ev.data.data.link ;
            done();
        }) ;
    }.bind(this)) ;
} ;


notificationController.onMarkAll = function() {
    this.view.longTask(function(done){
        var records = [] ;
        this.data.notifs.forEach(function(notif){
            if (notif.state == "new" || notif.state == "sent") {
                records.push({
                    table: "iz_notification",
                    action: "update",
                    record : { id: notif.id, state: "view"}
                }) ;
            }
        }) ;
        this.api.db.transactionalChanges(records, function(err){
            if(err){ return done(err); }
            this.view.close() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

notificationController.onShowReadNotifications = function(ev){
    this.view.updateData();
    var checked = !!this.data.showReadNotifications;

    this.view.longTask(function(done){
        this.api.db.transactionalChanges([
            {
                table: "iz_map",
                action: "insertOrUpdate",
                conditions: {
                    code: "notification_popup",
                    user_uid: this.api.currentUser.id,
                    key: "showReadNotifications",
                    realm_code: ''
                },
                record: {
                    code: "notification_popup",
                    user_uid: this.api.currentUser.id,
                    key: "showReadNotifications",
                    realm_code: '',
                    value: { showReadNotifications: checked }
                }
            }
        ], function(err){
            if(err){ return done(err); }
            if(this._allNotifs){
                if(checked){
                    this.data.notifs = this._allNotifs;
                }else{
                    this.data.notifs = this._allNotifs.filter(function(n){ return n.state !== 'view'; });
                }
                this.data.readCount = this._allNotifs.filter(function(n){ return n.state === 'view'; }).length;
                (this.view||this).render();
            }
            done();
        }.bind(this));
    }.bind(this));
};

notificationController.onShowReadCount = function() {
    this.data.showReadNotifications = true;

    this.view.longTask(function(done){
        this.api.db.transactionalChanges([
            {
                table: "iz_map",
                action: "insertOrUpdate",
                conditions: {
                    code: "notification_popup",
                    user_uid: this.api.currentUser.id,
                    key: "showReadNotifications",
                    realm_code: ''
                },
                record: {
                    code: "notification_popup",
                    user_uid: this.api.currentUser.id,
                    key: "showReadNotifications",
                    realm_code: '',
                    value: { showReadNotifications: true }
                }
            }
        ], function(err){
            if(err){ return done(err); }
            if(this._allNotifs){
                this.data.notifs = this._allNotifs;
                this.data.readCount = this._allNotifs.filter(function(n){ return n.state === 'view'; }).length;
                (this.view||this).render();
            }
            done();
        }.bind(this));
    }.bind(this));
};

module.exports = notificationController ;